import { standard } from '../../constants';

export default {
  RESET_CLOCK: 'RESET_CLOCK',
  SET_CLOCK: 'SET_CLOCK',
  SET_PERIOD: 'SET_PERIOD',
  START_CLOCK: 'START_CLOCK',
  STOP_CLOCK: 'STOP_CLOCK',
  ...standard('CREATE', 'codings'),
  ...standard('DELETE', 'codings'),
  ...standard('GET', 'codings'),
  ...standard('UPDATE', 'codings')
};



// WEBPACK FOOTER //
// ./src/modules/coding/constants.js